/**
 * Platform "me" lane identity (design 5.2, platform discriminant):
 * `entitlements: null` — the /api/me/ per-operator self-service surface is
 * deliberately un-licensed (it is in the decided-free UNGATED_PREFIXES
 * allowlist), and platform registrations each carry a reason. This identity
 * exists so frontend-consumed /api/me endpoints have contracts (5.3.1) —
 * a frontend feature file may carry no raw '/api/' literal, gated or not.
 */

import { defineIdentity } from '../featureModule'

export const identity = defineIdentity({
  name: 'me',
  entitlements: null,
})
